import React from 'react';
import styled from 'styled-components';
import useTranslation from 'shared/hooks/useTranslation';
import { COLORS } from 'config/theme';
import { BadgeProps } from '../badgesData';

const StyledDescription = styled.div`
  color: ${COLORS.PRIMARY};
  font-size: 2.8rem;
  line-height: 1.3;
  padding-top: 1.6rem;
  text-align: left;

  b {
    font-size: 3.6rem;
    line-height: 1;
    padding: 0 1rem;
  }

  @media (-webkit-min-device-pixel-ratio: 1.25) {
    font-size: 1.4rem;

    b {
      font-size: 1.6rem;
    }
  }

  ${({ theme }) => theme.MEDIA.MD} {
    color: white;
  }
`;

export default function Description({ badgeName }: Pick<BadgeProps, 'badgeName'>): JSX.Element {
  const { t } = useTranslation('badgesPage');

  return <StyledDescription dangerouslySetInnerHTML={{ __html: t(`badges.description.${badgeName}`) }} />;
}
